const initialState ={
  refresh:0,
  main_deals:{}
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case 'REQUEST_DELETE_DEAL_PIPELINE_SUCCESS':
    case 'REQUEST_CREATE_DEAL_PIPELINE_SUCCESS':
    case 'REQUEST_INDEX_DEAL_PIPELINES_SUCCESS':
      newState.pipelines=action.val;
      newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_DEAL_PIPELINE_SUCCESS':
      window.location.href='/sales_coach/setup';
      break;
    case 'REQUEST_DELETE_DEAL_SUCCESS':
      delete newState.deals[action.val.company_id][action.val.id];
      newState.refresh+=1;
      newState.deals_loading=false;
      break;
    case 'REQUEST_DEAL_LOADING':
      newState.deals_loading=action.val;
      break;
    case 'REQUEST_CREATE_DEAL_SUCCESS':
    case 'REQUEST_GET_DEAL_SUCCESS':
    case 'REQUEST_UPDATE_DEAL_SUCCESS':
      if(newState.deals==undefined){newState.deals={}}
      if(newState.deals[action.val.company_id]==undefined){newState.deals[action.val.company_id]={}}
      newState.deals[action.val.company_id][action.val.id]={...action.val};
      if(action.val.main==true){newState.main_deals[action.val.company_id]=action.val.id;}
      newState.refresh+=1;
      newState.deals_loading=false
      break;
    case 'REQUEST_INDEX_DEALS_SUCCESS':
      if(newState.deals==undefined){newState.deals={}}
      //Need to have it show as empty if empty not undefined;
      if(newState.deals[action.company_id]==undefined){newState.deals[action.company_id]={}}
      if(action.val.length>0){
        newState.main_deals[action.val[0].company_id]=action.val[0].id;
        for(let x of action.val){
          if(x.main==true){newState.main_deals[x.company_id]=x.id;}
          if(newState.deals[x.company_id]==undefined){newState.deals[x.company_id]={}} newState.deals[x.company_id][x.id]=x;
        }
      }
      console.log('NEW DEALS', newState);
      newState.refresh+=1;
      newState.deals_loading=false
      break;
    case 'REQUEST_DELETE_CUSTOM_DEAL_FIELD_SUCCESS':
      delete newState.custom_fields[action.val];
      newState.refresh+=1;
      break;
    case 'REQUEST_CREATE_CUSTOM_DEAL_FIELD_SUCCESS':
    case 'REQUEST_GET_CUSTOM_DEAL_FIELD_SUCCESS':
    case 'REQUEST_UPDATE_CUSTOM_DEAL_FIELD_SUCCESS':
      if(newState.custom_fields==undefined){newState.custom_fields={}}
      if(newState.custom_contact_fields==undefined){newState.custom_contact_fields={}}
      if(newState.custom_user_fields==undefined){newState.custom_user_fields={}}
      if(action.val.type==0){newState.custom_fields[action.val.id]={...action.val};}
      else if(action.val.type==1){newState.custom_contact_fields[action.val.id]={...action.val};}
      else if(action.val.type==2){newState.custom_user_fields[action.val.id]={...action.val};}
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_CUSTOM_DEAL_FIELDS_SUCCESS':
      if(newState.custom_fields==undefined){newState.custom_fields={}}
      if(newState.custom_contact_fields==undefined){newState.custom_contact_fields={}}
      if(newState.custom_user_fields==undefined){newState.custom_user_fields={}}
      for(let x of action.val){
        if(x.type==0){
          if(newState.custom_fields[x.id]==undefined){newState.custom_fields[x.id]={}} newState.custom_fields[x.id]={...newState.custom_fields[x.id], ...x};
        }else if(x.type==1){
          if(newState.custom_contact_fields[x.id]==undefined){newState.custom_contact_fields[x.id]={}} newState.custom_contact_fields[x.id]={...newState.custom_contact_fields[x.id], ...x};
        }else if(x.type==2){
          if(newState.custom_user_fields[x.id]==undefined){newState.custom_user_fields[x.id]={}} newState.custom_user_fields[x.id]={...newState.custom_user_fields[x.id], ...x};
        }
      }
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_DEALS':
    case 'REQUEST_UPDATE_DEAL':
    case 'REQUEST_CREATE_DEAL':
    case 'REQUEST_DELETE_DEAL':
    case 'REQUEST_QUIZZ_QUESTION_COMPLETED':
    case 'REQUEST_CLICK_SALES_COACH_CHECKLIST':
        newState.deals_loading=true
      break;
    case 'REQUEST_CLICK_SALES_COACH_CHECKLIST_FAIL':
        newState.deals_loading=false;
      break;
    }
  return newState;
}

export default reducer;
